// @flow
import { IState } from '../../app/types';
import { openDialog } from '../../base/dialog';
import { translate } from '../../base/i18n';
import { IconFaceRegistration} from '../../base/icons';
import { connect } from '../../base/redux';
import { AbstractButton } from '../../base/toolbox/components';
import type { AbstractButtonProps } from '../../base/toolbox/components';
import { isFaceRecognitionEnabled, checkFilterSupport } from '../../face-recognition/functions';

import { FaceRegistration } from './index';

/**
 * The type of the React {@code Component} props of {@link FaceRegistrationButton}.
 */
type Props = AbstractButtonProps & {
    /**
     * The redux {@code dispatch} function.
     */
    dispatch: Function
};

/**
 * An abstract implementation of a button that toggles the video background dialog.
 */
class FaceRegistrationButton extends AbstractButton<Props, *> {
    accessibilityLabel = 'toolbar.faceRegistration';
    icon = IconFaceRegistration;
    buttonLabel = 'toolbar.faceRegistration';
    label = 'toolbar.faceRegistration';
    tooltip = 'toolbar.faceRegistration';

     

    /**
     * Handles clicking / pressing the button, and toggles the virtual background dialog
     * state accordingly.
     *
     * @protected
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(openDialog(FaceRegistration));
    }
 /**
     * Returns {@code boolean} value indicating if the background effect is
     * enabled or not.
     *
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isFaceRecognitionEnabled;
    }
}

/**
 * Maps (parts of) the redux state to the associated props for the
 * {@code FaceRegistrationButton} component.
 
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _isBackgroundEnabled: boolean
 * }}
 */
function _mapStateToProps(state: IState): Object {
    return {
        _isFaceRecognitionEnabled: isFaceRecognitionEnabled(state),
        visible: checkFilterSupport()
    };
}

export default translate(connect(_mapStateToProps)(FaceRegistrationButton));
